import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { NewsView, WP_News } from '../model/models';
import { ModelsService } from '../services/ModelsService';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';
import { useWP } from './WPHooks';

export function useNewsModal(news: NewsView | undefined): {
  authorImgUrl;
  houseName;
  differenceTime;
} {
  const authorImgUrl = news?.authorImgUrl;

  const houseName = news?.authorName;

  let differenceTime = '';

  if (news) {
    let numberOfSec = moment(news.news_date);
    let now = moment();
    differenceTime = numberOfSec.from(now);
  }

  return { authorImgUrl, houseName, differenceTime };
}

export function useNewsView(slug: string): {
  news: NewsView | undefined;
  notFound: boolean;
} {
  const { state, dispatch } = useContext(AppContext);

  const { wp } = useWP();

  const [notFound, setNotFound] = useState<boolean>(false);

  const requirements = [state.news, state.user, state.locale, slug];

  useEffect(() => {
    const news = state.news.get(slug);
    if (
      news === undefined &&
      requirements.every((requirement) => requirement) &&
      !state.news.has(slug)
    ) {
      // fetch the news and update global state and local state
      const mainHouseId = state.mainHouse?.id || 0;
      wp.getNews(state.locale, slug)
        .then((news: WP_News[]) => {
          return news.map((n) => {
            return ModelsService.toNewsView(
              mainHouseId,
              ModelsService.getUserActiveHouse(state.user)?.term_id || 0,
              n,
              state.allHouses,
              state.allServices,
              state.user?.acf.locale
            );
          });
        })
        .then((newsViews: NewsView[]) => {
          if (newsViews.length === 1) {
            dispatch({ type: ActionType.AddNews, payload: newsViews });
          } else {
            setNotFound(true);
          }
        })
        .catch((e) => {
          setNotFound(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, requirements);

  return { news: state.news.get(slug), notFound: notFound };
}
